import {Component, Input} from '@angular/core';
import {Materiale} from '../../_models/Materiale';
import {ModalController} from '@ionic/angular';
import {ArticoloGiacenzaModalComponent} from "../giacenza/articolo-giacenza-modal/articolo-giacenza-modal.component";

@Component({
  selector: 'app-materiale-list',
  templateUrl: './materiale-list.component.html',
  styleUrls: ['./materiale-list.component.scss'],
  standalone: false
})
export class MaterialeListComponent {
  @Input() materiali: Materiale[];

  constructor(
    private modalCtrl: ModalController) { }

  async openGiacenza(materiale: Materiale) {
    const modal = await this.modalCtrl.create({
      component: ArticoloGiacenzaModalComponent,
      backdropDismiss: false,
      componentProps: {codArt: materiale.codArt},
      cssClass: 'custom-modal'
    });
    await modal.present();
    await modal.onWillDismiss();
  }
}
